import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

//UI
import { Table, Breadcrumb, Divider, Loader, Button, Modal, Icon, Message, Form } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import LogsHistory from "../../../../components/reservation/logsHistory";
import { Accordion } from "semantic-ui-react";
import { Collapse } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

//Actions
import { fetchBookingLogs } from "../../../../redux/actions/reservations/booking/fetchBookingsLogs";
import { initialStateBooking } from "../../../../redux/actions/reservations/booking/fetchBooking";
import { deleteBooking } from "../../../../redux/actions/reservations/booking/deleteBooking";
import { fetchBookingListCustom, initialStateBookingListCustom } from "../../../../redux/slices/custom/reservations/cruise/booking/customBookingList.slice";
import { canceledBooking, initialStateCancelBooking } from "../../../../redux/slices/custom/reservations/cruise/booking/canceledBooking";

//Components
import HeaderCatalog from "../../../../components/headerCatalog";
import HeadDetail from "../../../../components/headDetail";
import HeadDetailReservation from "../../../../components/headDetailReservation";

// Resources
import { scrollToTop } from "../../../resources/utils";
import { useForm } from "react-hook-form";

export default function BookingList() {
  let { cruise_id } = useParams();
  let { reservation_id } = useParams();
  const { t } = useTranslation();
  const bookingStateCustom = useSelector((state) => state.customBookingList);
  const bookingState = useSelector((state) => state.bookingReducer);
  const cancelBookingState = useSelector((state) => state.cancelBooking);
  const bookingLogsState = useSelector((state) => state.bookingLogReducer);
  const { register, errors, handleSubmit } = useForm();

  const [bookingId, setBookingId] = useState("");;
  const [noteCanceled, setNoteCanceled] = useState();

  const dispatch = useDispatch();
  var total = 0;

  const [openHistory, setOpenHistory] = useState(false);

  useEffect(() => {
    scrollToTop();
    dispatch(fetchBookingListCustom(reservation_id, cruise_id));
    return () => {
      dispatch(initialStateBookingListCustom());
      dispatch(initialStateBooking());
    };
  }, []);

  if (bookingStateCustom.fetching || bookingState.fetching) {
    return <Loader active inline />;
  }

  if (bookingStateCustom.processing) {
    return <Loader active inline />;
  }

  if (bookingState.message === "resource deleted successfully") {
    dispatch(fetchBookingListCustom(reservation_id, cruise_id));
    dispatch(fetchBookingLogs(reservation_id));
    dispatch(initialStateBooking());
  }

  if (cancelBookingState.message === "resource canceled successfully") {
    dispatch(fetchBookingListCustom(reservation_id, cruise_id));
    dispatch(fetchBookingLogs(reservation_id));
    dispatch(initialStateCancelBooking());

  }

  const onSubmit = (data) => {
    dispatch(canceledBooking(bookingId, data));
    setNoteCanceled();
  };

  const handleHistoyClick = () => {
    setOpenHistory(!openHistory);
    if (!openHistory) {
      dispatch(fetchBookingLogs(reservation_id));
    }
  };

  bookingStateCustom.bookings.map((booking) => (
    total = total + booking.price
  ));

  return (
    <>
      {bookingState.error ? (
        <Message negative content={t(bookingState.error)} />
      ) : (
        ""
      )}
      <Breadcrumb>
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/cruise-detail`} className="section">{bookingStateCustom.cruise.code}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations`} className="section"> {t("reservation_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active> {t("booking_title")}</Breadcrumb.Section>
      </Breadcrumb>
      <Divider variant="fullWidth" />
      <HeadDetail yacht_name={bookingStateCustom.cruise.yacht_name} cruise_name={bookingStateCustom.cruise.name} itinerary_name={bookingStateCustom.cruise.itinerary_name} start_date={bookingStateCustom.cruise.start_date_format} end_date={bookingStateCustom.cruise.end_date_format} />
      <HeadDetailReservation reservation_date={bookingStateCustom.reservation.creation_date} reservation_agency={bookingStateCustom.reservation.agency_name} reservation_executive={bookingStateCustom.reservation.user} reservation_type={bookingStateCustom.reservation.cruise_type} />
      <br></br>

      <HeaderCatalog title={t("booking_title")} message={bookingStateCustom.message} to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings_new`} />
      <div style={{ width: "100%", overflowX: "auto" }}>
        <Table unstackable>
          <Table.Header>
            <Table.Row align="center">
              <Table.HeaderCell>{t("booking_code")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_executive")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_creation_date")}<br /><span className="text_date_format">(dd-mm-yyyy)</span></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_cabin")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_single")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_double")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_family")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_price")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_space")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {bookingStateCustom.bookings.map((booking) => (
              <Table.Row align="center">
                <Table.Cell>{booking.id}</Table.Cell>
                <Table.Cell>{booking.user}</Table.Cell>
                <Table.Cell>{booking.creation_date}</Table.Cell>
                <Table.Cell>
                  <div className="active_tag">
                    <div className="cabin_active">
                      {booking.cabin_name}
                    </div>
                  </div>
                </Table.Cell>
                <Table.Cell>
                  {booking.single === 1 ? (
                    <div className="active_tag">
                      <div className="bed_active">
                        {t("booking_bed_active")}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {booking.matrimonial === 1 ? (
                    <div className="active_tag">
                      <div className="bed_active">
                        {t("booking_bed_active")}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {booking.family_room === 1 ? (
                    <div className="active_tag">
                      <div className="bed_active">
                        {t("booking_bed_active")}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Table.Cell>
                <Table.Cell><b>$ {booking.price}</b></Table.Cell>
                <Table.Cell>
                  {" "}
                  {booking.spaces !== null ? (
                    <Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking.id}/spaces`}>
                      {booking.spaces}
                    </Link>
                  ) : (
                    <Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking.id}/spaces`}>
                      <Button className="add_button" icon circular size="mini">
                        <Icon className="icon_color" name="add" />
                      </Button>
                    </Link>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/cruises/${cruise_id}/reservations/${booking.reservation_id}/booking/${booking.id}`}>
                    <Button className="edit_button" icon>
                      <Icon className="icon_color" name="pencil alternate" />
                    </Button>
                  </Link>
                  <Modal
                    trigger={
                      <Button
                        className="delete_button"
                        icon
                        onClick={() => setBookingId(booking.id)}
                      >
                        <Icon name="times circle" className="icon_color" />
                      </Button>
                    }
                    header={
                      <p
                        style={{
                          color: "black",
                          fontSize: "18px",
                          fontWeight: "bold",
                          paddingTop: "15px",
                          paddingLeft: "20px",
                        }}
                      >
                        {t("reservation_cancelation_message")}
                      </p>
                    }
                    content={
                      <Form
                        onSubmit={handleSubmit(onSubmit)}
                        style={{
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          paddingBottom: "25px",
                        }}
                      >
                        <textarea
                          rows="3"
                          name="reason_cancellation"
                          defaultValue={noteCanceled}
                          style={{ minHeight: 200 }}
                          placeholder={t("reservation_canceled_text")}
                          ref={register({ required: true })}
                        />
                        {errors.reason_cancellation && (<span className="error_message">{t("required_information")}</span>)}
                        <br></br>
                        <br></br>
                        <button
                          type="submit"
                          className={
                            bookingStateCustom.processing
                              ? "ui loading primary button"
                              : "ui primary button"
                          }
                        >
                          {t("cancel_reservation_button")}
                        </button>
                      </Form>
                    }
                    actions={[t("close_button")]}
                    size="tiny"
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>

          <Table.Footer>
            <Table.Row align="center">
              <Table.HeaderCell><b>TOTAL:</b></Table.HeaderCell>
              <Table.HeaderCell />
              <Table.HeaderCell />
              <Table.HeaderCell />
              <Table.HeaderCell />
              <Table.HeaderCell />
              <Table.HeaderCell />
              <Table.HeaderCell><b>$ {total.toFixed(2)}</b></Table.HeaderCell>
              <Table.HeaderCell />
              <Table.HeaderCell />
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>

      <span style={{ fontWeight: "bold", fontSize: "18px", color: "red" }}>{t("booking_canceled")}</span>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <Table color="blue" unstackable>
          <Table.Header>
            <Table.Row align="center">
              <Table.HeaderCell>{t("booking_code")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_executive")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_creation_date")}<br /><span className="text_date_format">(dd-mm-yyyy)</span></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_cabin")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_single")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_double")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell>{t("booking_family")}<br /><br /></Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          {bookingStateCustom.bookingsCanceled.map((booking) => (
            <Table.Body>
              <Table.Row align="center">
                <Table.Cell>{booking.id}</Table.Cell>
                <Table.Cell>{booking.user}</Table.Cell>
                <Table.Cell>{booking.creation_date}</Table.Cell>
                <Table.Cell>
                  <div className="active_tag">
                    <div className="cabin_active">
                      {booking.cabin_name}
                    </div>
                  </div>
                </Table.Cell>
                <Table.Cell>
                  {booking.single === 1 ? (
                    <div className="active_tag">
                      <div className="bed_active">
                        {t("booking_bed_active")}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {booking.matrimonial === 1 ? (
                    <div className="active_tag">
                      <div className="bed_active">
                        {t("booking_bed_active")}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {booking.family_room === 1 ? (
                    <div className="active_tag">
                      <div className="bed_active">
                        {t("booking_bed_active")}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Table.Cell>

              </Table.Row>
              <Table.Row className="h-[30px] ">
                <Table.HeaderCell colSpan="1" className="pl-2 bg-yellow-50">{t("space_cancelation_reason")}:</Table.HeaderCell>
                <Table.HeaderCell colSpan="7" className="pl-2 bg-yellow-50">{booking.reason_cancellation}</Table.HeaderCell>
              </Table.Row>
            </Table.Body>
          ))}
        </Table>
      </div>
      <Accordion styled style={{ width: "100vw" }}>
        <Accordion.Title onClick={handleHistoyClick} style={{ display: "flex", gap: "5px" }}>
          {t("log_historical")}
          {openHistory ? <ExpandLess /> : <ExpandMore />}
        </Accordion.Title>
        {bookingLogsState.fetching ? (
          <div style={{ display: "flex", width: "100vw", height: "80px", justifyContent: "center" }}>
            <Loader size="medium" active inline>Loading...</Loader>
          </div>
        ) : (
          <Collapse in={openHistory} timeout="auto" unmountOnExit style={{ padding: "15px" }}>
            <LogsHistory
              logsHistory={bookingLogsState.logs}
            />
          </Collapse>
        )}
      </Accordion>
    </>
  );
}
